// extracted by mini-css-extract-plugin
export default {"price":"I7-z","priceRow":"J7-z","onSale":"K7-z","msrpLabelPrice":"L7-z","msrpLabel":"M7-z","originalPrice":"N7-z","percentOff":"O7-z"};